"use client";

import React from "react";
import { ArrowRight, CircleAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function BlogPostsGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="78264" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="border-none bg-transparent overflow-hidden">
            <div className="aspect-[4/3] bg-secondary animate-pulse rounded-2xl" />
            <CardContent className="p-6 flex flex-col gap-4">
              <div className="h-5 w-24 bg-secondary animate-pulse rounded" />
              <div className="h-8 w-full bg-secondary animate-pulse rounded" />
              <div className="h-8 w-2/3 bg-secondary animate-pulse rounded" />
              <div className="mt-4 h-5 w-24 bg-secondary animate-pulse rounded" />
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center bg-destructive/5 rounded-2xl border border-destructive/10">
        <CircleAlert className="w-8 h-8 text-destructive mb-4" />
        <p className="text-foreground font-default font-medium">Er is een fout opgetreden bij het laden van de inzichten.</p>
        <p className="text-muted-foreground text-sm mt-1">Onze systemen worden momenteel bijgewerkt.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center py-12 bg-secondary/30 rounded-2xl border border-border/50">
        <p className="text-muted-foreground font-default">Er zijn momenteel geen nieuwe inzichten beschikbaar.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group border-none hover:shadow-none transition-all duration-300 overflow-hidden bg-transparent flex flex-col h-full">
          <Link to={post.link || "#"}>
            <div className="aspect-[4/3] bg-secondary/50 relative overflow-hidden rounded-2xl">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-accent">
                  <span className="text-accent-foreground/40 font-mono text-xs uppercase tracking-widest">Connected Online</span>
                </div>}
            </div>
          </Link>
          
          <CardContent className="px-0 py-6 flex flex-col flex-grow gap-4">
            {post.categories && post.categories.length > 0 && <Badge variant="secondary" className="w-fit bg-accent text-accent-foreground hover:bg-accent/20 border-none font-mono text-[10px] uppercase tracking-widest px-2 py-0.5">
                {post.categories[0].name}
              </Badge>}
            
            <Link to={post.link || "#"}>
              <h3 className="font-default text-2xl md:text-3xl font-semibold leading-tight text-foreground group-hover:underline decoration-accent-foreground/30 underline-offset-4 transition-all line-clamp-3">
                {post.title}
              </h3>
            </Link>
            
            <div className="mt-auto pt-2">
              <Button variant="link" className="p-0 h-auto text-accent-foreground font-default font-semibold group/btn" asChild>
                <Link to={post.link || "#"}>
                  Lees artikel
                  <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover/btn:translate-x-1" />
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function InzichtenHerstel() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="digitale-inzichten" className="text-foreground py-16 !bg-[hsl(20,100%,98%)] md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <h2 className="font-default text-3xl md:text-4xl lg:text-6xl font-bold text-foreground mb-4 tracking-tighter">Online Inzichten</h2>
            <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed max-w-xl">Ontdek de laatste trends in AI, marketing automatisering en groei voor ondernemingen.</p>
          </div>
          
          <Button variant="outline" className="w-fit shrink-0 rounded-lg border-foreground/10 bg-[#fff9f6] hover:bg-foreground hover:text-background transition-colors px-8 py-6 h-auto font-default font-semibold" asChild>
            <Link to="#">
              Bekijk alle artikelen
            </Link>
          </Button>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <BlogPostsGrid />
        </PostsProvider>
      </div>
    </section>;
}